import { useAuth0 } from "@auth0/auth0-react";
import Grid from "@mui/material/Grid";
import { ReactComponent as ArrowDown } from "assets/icons/ArrowDown.svg";
import { ReactComponent as ArrowTop } from "assets/icons/ArrowTop.svg";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import { InputField } from "components/InputField/InputField";
import { LabelField } from "components/LabelField";
import Loader from "components/loader/Loader";
import SearchComp from "components/Searchcomponent";
import { Template } from "components/Template/Template";
import { InfiniteScroll } from "helpers/InfiniteScroll/InfiniteScroll";
import CommunicationService from "Lib/API/Communication/index";
import { debounce } from "lodash";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import Select, { components } from "react-select";
import { setCardContent, setIsFromSelectedStep, setSelectedTemplate } from "services/api/communication";
import { CreateAutomationForm } from "../../CreateAutomationForm/CreateAutomationForm";
import { Footer } from "../../Footer/Footer";
import { PreviewTemplate } from "../PreviewTemplate/PreviewTemplate";
import {
  CampaignSectionWrapper,
  CheckBoxWrapper,
  NoContentWrapper,
  SearchWrapper,
  SelectTemplateSction,
  TemplateListContent,
  TemplateName,
  Title,
  Wrapper,
} from "../Theme";
import {
  ArrowButton,
  ButtonItem,
  EventType,
  Input,
  InputWrapper,
  TreggarButtons,
  WrapperButtons,
} from "./Theme";
const MyTemplateCreateAutomation = ({
  formik,
  onNext,
  cardContent,
  setViewTemplate,
  viewTemplate,
  setActiveStep,
  onBack,
  eventTypes
}) => {
  const minDate = new Date();
  const [sortBy, setSortBy] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(1);
  const { getAccessTokenSilently } = useAuth0();
  const [hasMore, setHasMore] = useState(true);
  const [refresh, setRefresh] = useState(false);
  const dispatch = useDispatch();
  const [search, setSearch] = useState({
    search: undefined,
  });
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [templateList, setTemplateList] = useState([]);
  const listRef = useRef(null);
  const lastScrollOffset = useRef(0);
  const types = ["Before", "One The Day", "After"];
  const dateTypes = ["Day", "Month", "Year"];
  const [show, setShow] = useState("Before");
  const [showDate, setShowDate] = useState("Day");
  const [value, setValue] = useState(0);

  const increment = () => setValue(value + 1);
  const decrement = () => setValue(value - 1);
  const { selectedTemplate, automationEditData } = useSelector(
    (state) => state.communication
  );
  const [dropDownType, setDropDownType] = useState({
    label: "Communications",
    value: "communication",
  });
  const [dropDownTypeAudience, setDropDownTypeAudience] = useState({});

  const selectControlStyles = {
    backgroundColor: "transparent",
    borderColor: "#E1E1E7",
    color: "#b5b5c3",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    paddingTop: "6px",
    paddingBottom: "6px",
    cursor: "pointer",
    width: "312px",
    height: "48px",
  };
  const buttons = viewTemplate
    ? [
      {
        name: "Previous",
        action: () => {
          setViewTemplate(false);
          dispatch(setIsFromSelectedStep(false));
        },
        isDisabled: false,
        type: "secondary",
        marginRight: "53rem",
        width: "100px",
        variant : "primary-outline"
      },
      {
        name: "Edit",
        action: () => {
          onNext();
          setViewTemplate(false);
          dispatch(setIsFromSelectedStep(false));
        },
        isDisabled: false,
        type: "secondary",
        width: "100px",
        variant : "primary"
      },
      {
        name: "Select",
        action: () => {
          setActiveStep(2);
          dispatch(setIsFromSelectedStep(true));
        },
        isDisabled: false,
        type: "primary",
        width: "100px",
        variant : "primary"
      },
    ]
    : [
      {
        name: "Previous",
        action: () => {
          onBack();
        },
        isDisabled:
          Object.keys(automationEditData)?.length > 0 ? true : false,
        type: "secondary",
        width: "100px",
        marginRight: "53rem",
        variant : "primary-outline"
      },
      {
        name: "Next",
        action: () => {
          setViewTemplate(true);
        },
        width: "100px",
        isDisabled: Object.keys(automationEditData)?.length
          ? Object.keys(automationEditData)?.length === 0 ||
          !formik.values?.automationName ||
          !formik?.values?.eventType ||
          formik?.values?.account?.audiences?.length === 0 ||
          !formik.values?.timeExecute?.timeType
          : Object.keys(selectedTemplate)?.length === 0 ||
          !formik.values?.automationName ||
          !formik?.values?.eventType ||
          formik?.values?.account?.audiences?.length === 0 ||
          !formik.values?.timeExecute?.timeType,
        type: "primary",
        variant : "primary"
      },
    ];
  const dateTimeMask = [
    /\d/,
    /\d/,
    "/",
    /\d/,
    /\d/,
    "/",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    " ",
    /\d/,
    /\d/,
    ":",
    /\d/,
    /\d/,
    " ",
    /a|p/i,
    "M",
  ];

  const getTempleteList = async (initialPage) => {
    const currentPage = initialPage || page;
    
    if (loading || !hasMore) return;

    setLoading(true);
    const filterData = {
      search: search?.search,
      filter: {
        type: formik.values?.eventType?.templateType ? formik.values?.eventType?.templateType : undefined,
      }
    };
    try {
      const token = await getAccessTokenSilently();
      const result = await CommunicationService.getTemplateList(
        token,
        currentPage,
        10,
        filterData
      );
      setCount(result?.pagination?.count);
      setTemplateList(currentPage === 1 ? result?.result :(prevList) => [...prevList, ...result?.result]);
      setPage(currentPage === 1 ? 2 : (prevPage) => prevPage + 1);
    } catch (err) {
      toastr.error("Error", err?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const debounceSearch = useCallback(
    debounce(() => {
      if (search) {
        getTempleteList();
      }
    }, 500),
    [search, sortBy, refresh]
  );
  useEffect(() => {
    if (searchValue === "") {
      setSearch({ search: undefined });
    } else {
      setSearch({ search: searchValue });
      setPage(1);
      setTemplateList([]);
    }
  }, [searchValue]);

  useEffect(() => {
    if(!formik.values?.eventType?.value) return;
    if (search?.search) {
      debounceSearch();
    } else {
      getTempleteList(1);
    }
    return () => debounceSearch.cancel();
  }, [search, sortBy, refresh, formik.values?.eventType]);

  function convertUTCToLocalDate(date) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes()
    );
    return date;
  }

  function convertLocalToUTCDate(date, name) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes()
      )
    );
    formik.setFieldValue(name, date);
    return date;
  }

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    const regex = /[\*\(\)\+]/;
    if (!regex.test(inputValue)) {
      setSearchValue(inputValue);
    }
  };
  const itemCount = Math.ceil(templateList.length / 3);
  const handleScroll = ({
    scrollDirection,
    scrollOffset,
    scrollUpdateWasRequested,
  }) => {
    if (
      scrollDirection === "forward" &&
      !loading &&
      !scrollUpdateWasRequested
    ) {
      const totalHeight = 260 * itemCount; // Assuming item height is 320px
      if (scrollOffset > totalHeight - 630 * 2) {
        templateList.length !== count && getTempleteList();
      }
    }
    lastScrollOffset.current = scrollOffset;
  };

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <BottomArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };

  useEffect(() => {
    if (listRef.current && lastScrollOffset.current) {
      listRef.current.scrollTo(lastScrollOffset.current);
    }
  }, [templateList]);

  const formatOptionLabel = ({ label, _id }) => {
    return (
      <div className="dropdown-container" key={_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{label}</div>
          </div>
        </div>
      </div>
    );
  };
  const selectStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
    }),
    menuList: (styles) => ({
      ...styles,
      maxHeight: "200px",
    }),
  };

  const Row = ({ index, style }) => {
    return (
      <Grid container spacing={1} style={style}>
        {templateList.slice(index * 3, index * 3 + 3).map((template, idx) => (
          <Grid item xs={4} key={idx}>
            <Template
              selectedTemplate={
                automationEditData?.template?._id === template?._id ||
                selectedTemplate?._id === template?._id
              }
              Content={
                <div
                  onClick={() => {
                    dispatch(setSelectedTemplate(template));
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={template?.thumbnail}
                    alt="Not Found"
                    style={{
                      minWidth: "167px",
                      width: "167px",
                      minHeight: "150px",
                      height: "150px",
                    }}
                  />
                  <TemplateName>
                    <span>{template?.title}</span>
                  </TemplateName>
                </div>
              }
            />
          </Grid>
        ))}
      </Grid>
    );
  };
  return (
    <>
      {viewTemplate ? (
        <>
          <PreviewTemplate
            selectedTemplate={
              Object.keys(selectedTemplate)?.length > 0
                ? selectedTemplate
                : automationEditData?.template
            }
          />
          <Footer
            type={cardContent}
            buttons={buttons}
            Wrapperstyle={{
              width: "84%",
              justifyContent: "center",
              marginButton: "10px",
            }}
          />
        </>
      ) : (
        <>
          {" "}
          <CreateAutomationForm
            formik={formik}
            onNext={onNext}
            onBack={() => dispatch(setCardContent("Create Campaign"))}
            cardContent={cardContent}
            buttonsProps={buttons}
            dropDownType={eventTypes}
            children={
              

                  <SelectTemplateSction>
                    <Title>
                      Select Template
                      <label style={{ fontWeight: "500", color: "red" }}>
                        {" *"}
                      </label>
                    </Title>
                    <br />
                    {formik.values?.eventType?.value && (
                        <>
                        <SearchWrapper>
                          <SearchComp
                            value={searchValue}
                            setSearchText={handleInputChange}
                            placeholder="Search"
                            style={{
                              width: "312px",
                              height: "48px !important",
                              backgroundColor: "#fff",
                            }}
                          />
                        </SearchWrapper>
                        <br />
                        <TemplateListContent>
                          <div>
                            <InfiniteScroll
                              height={213}
                              itemCount={itemCount}
                              itemSize={200}
                              width="100%"
                              onScroll={handleScroll}
                              ref={listRef}
                            >
                              {Row}
                            </InfiniteScroll>
                            {loading && (
                              <NoContentWrapper style={{ height: "320px" }}>
                                <Loader />
                              </NoContentWrapper>
                            )}
                          </div>
                        </TemplateListContent>
                        </>
                    )}
                  </SelectTemplateSction>
              

            }
          />
        </>
      )}

      <br />
    </>
  );
};

export default MyTemplateCreateAutomation;
